import { msg } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { decodeRendersSearch, type RendersSearch } from '~/lib/renders-search'
import { titleFor } from '~/lib/route-title'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/renders')({
  component: RendersLayout,
  head: () => ({ meta: [{ title: titleFor(msg`Renders`) }] }),
  validateSearch: (search: Record<string, unknown>): RendersSearch => decodeRendersSearch(search),
})

// Pass-through: the landing and the open project timeline are child routes.
function RendersLayout() {
  return <Outlet />
}
